<template>
  <div>
    <h2>
      {{ $title }}
      <add-button
        name="Order"
        icon-title="Add an Order"
        route-name="order_add"
        :disabled="!canManageOrders"
      />
      <a v-show="showExportButton" :href="exportUrl" download>
        <v-btn>Export XLSX</v-btn>
      </a>
    </h2>
    <OrderList :order="{}" path="order" />
  </div>
</template>

<script>
import OrderList from '@/components/table/OrderList'
import AddButton from '@/components/addButton.vue'
import { PERMISSIONS } from '@/constants/permissions'
import { useUserStore } from '@/stores/UserStore'

export default {
  components: {
    AddButton,
    OrderList,
  },

  setup() {
    return {
      userStore: useUserStore(),
    }
  },

  data() {
    return {
      orders: [],
      interval: null,
      pager: {
        loading: true,
        page: 1,
        total: 0,
        total_pages: 0,
        options: {},
      },
    }
  },

  computed: {
    canManageOrders() {
      return this.userStore.can(PERMISSIONS.MANAGE_ORDERS)
    },

    exportUrl() {
      if (!this.userStore.environment?.id) {
        return ''
      }

      return `${
        process.env.VUE_APP_API_URL + this.userStore.environment.id
      }/order/export`
    },

    showExportButton() {
      return this.userStore.hasRole('super-admin')
    },
  },
}
</script>
